import { Box, Image, Text } from "@chakra-ui/react";
import React from "react";
import bgImage from "../Components/bgImage/bgimage.png";
import { motion } from "framer-motion";

const Home = () => {
  
  return (
    <>
      <Box bgColor={"blackAlpha.900"} w={"full"} h={"85vh"}>

        <motion.div style={{
          height:"80vh",
        }}
        animate={{
          translateY:"20px"
        }}
        transition={{
          duration:1,
          repeat:Infinity,
          repeatType:"reverse"
        }}
        >
          <Image w={"full"} h={"full"} objectFit={"contain"} src={bgImage} />
        </motion.div>

        <Text
          fontSize={"6xl"}
          textAlign={"center"}
          fontWeight={"thin"}
          color={"tomato"}
          mt={"-20"}
          fontFamily={"Bebas Neue"}
        >
          Crypto<span style={{color:"#39FF14"}}>Pedia</span>
        </Text>
      </Box>
    </>
  );
};

export default Home;
//#141A2E
//#001010